<template>
    <Draggable
        mountPoint="#float-pannel-mount-point"
        movementBouncingEleSelector=".draggable-panel-bounce"
        :initialX="initialPos[0]"
        :initialY="initialPos[1]"
        class="dragpan"
        :reSet="reSet"
        @newPosition="pos => $emit('newPosition', pos)"
    >
        <template #grip>
            <div class="dragpan__topdraggrip" />
            <div class="draggable-wrapper__background--left" />
        </template>
        <main :class="['dragpan__container', {'dragpan__multisize': multisize}, 'size-' + multisize, classes]">
            <header class="dragpan-header">
                <table>
                    <tr>
                        <td class="dragpan-title">
                            {{ title }}
                        </td>
                        <td class="dragpan-topctrl__btn-wrap">
                            <div
                                v-if="multisize"
                                role="button"
                                aria-label="resize"
                                class="dragpan-resize-btn"
                                @click="onSwitchSize"
                            /><!--
                            --><div
role="button"
aria-label="close"
                                 class="dragpan-close-btn"
                                 @click="onClose('customFields')"
/>
                        </td>
                    </tr>
                </table>
            </header>

            <div class="dragpan-body" role="contentinfo">
                <slot name="body" />
            </div>
        </main>
    </Draggable>
</template>

<script>
import noop from 'lodash/noop';
import Draggable from '../Draggable';
export default {
    name: 'DragablePanel',
    components: {
        Draggable,
    },
    props: {
        initialPos: {
            type: Array,
            default: () => [0, 0],
        },
        title: {
            type: String,
            default: '',
        },
        classes: {
            type: String,
            default: '',
        },
        onClose: {
            type: Function,
            default: noop,
        },
        multisize: {
            type: Number,
            default: 0,
        },
        mountPoint: {
            type: String,
            default: '',
        },
        reSet: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            initialX: 300,
            curSize: 1,
        };
    },
    computed: {
    },
    methods: {
        onSwitchSize() {
            // eslint-disable-next-line eqeqeq
            let newSize = this.multisize == 1 ? 2 : 1;
            this.$emit('update:multisize', newSize);
        },
    },
};
</script>

<style lang="scss" scoped>
    .dragpan-header {
        table{
            width: 100%;
            border: none;
            border-collapse: collapse;
        }
    }

    .dragpan-title{
        line-height: 1;
        font-size: 16px;
        font-weight: 700;
        color: #061632;
    }
    .dragpan-resize-btn{
        background-position: center center;
        background-repeat: no-repeat;
        .size-1 & {
            background-image: url("../../../../../components/assets/images/maximum.svg");
        }
        .size-2 & {
            background-image: url("../../../../../components/assets/images/minimum.svg");
        }
    }

    .dragpan-close-btn{
        margin-left: 8px;
        background: url("../../../../../components/assets/images/header-v2/close.png") no-repeat center center;
    }
    .dragpan-resize-btn,
    .dragpan-close-btn{
        cursor: pointer;
        position: static;

        display: inline-block;
        width: 20px;
        height: 20px;
        background-size: 12.5px;
        /* for IE */
        filter:alpha(opacity=80);
        /* CSS3 standard */
        opacity:0.8;
        &:active{
            opacity: 0.2;
        }
    }

    .dragpan-topctrl__btn-wrap{
        vertical-align: top;
        white-space: nowrap;
        text-align: right;
        line-height: 1;
    }
</style>
<style lang="scss">
    $base-dragpan-dialog-padding-horizontal: 15px;

    .dragpan {
        .draggable-wrapper__background--left {
            display: none;
        }
    }
    .dragpan__container{
        background-color: #fefefe;
        border-radius: 4px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
        border: 1px solid #b3bac5;

        .draggable-wrapper__background--head{
            display: none;
        }
        .dragpan-header{
            padding: 9px #{$base-dragpan-dialog-padding-horizontal} 8px #{$base-dragpan-dialog-padding-horizontal};
            // border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        }
    }

    .dragpan__container.dragpan__multisize{
        max-width: 100vw;
        max-height: 100vh;
        &.size-1 {
            width: 280px;
            height: 406px;
            padding: 0;
        }
        &.size-2 {
            width: 512px;
            height: 564px;
            padding: 0;
        }
    }

    .dragpan__topdraggrip{
        position: absolute;
        top:0;
        left:0;
        right: 0;
        height: 2em;
        z-index: 0;
        cursor: grab;
    }

    .draggable-wrapper__background--left,
    .dragpan__topdraggrip {
        cursor: grab;
        .dragging & {
            cursor: grabbing;
        }
    }
</style>
